import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-maintenance-mode',
  templateUrl: './maintenance-mode.component.html',
  styleUrls: ['./maintenance-mode.component.css']
})
export class MaintenanceModeComponent implements OnInit {
  access: false;
  password: string = '';

  constructor( private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
          console.log(params.access);
          this.access = params.access;
        }
      );
  }

  grantAccess(): void{
    if (this.password === 'sistemas*ibec*2022'){
      localStorage.setItem('maintenance-access', 'true');
      this.router.navigate(['/']);
    }
  }

}
